import styled from 'styled-components';
import ButtonIcon from 'components/buttonIcon';

const Container = styled.li(
  ({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 2px;
    list-style: none;
    background: white;
    border-bottom: 1px solid var(--ghost-white);

    .info {
      width: 100%;
    }
    .label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 70vw;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      color: ${theme.default.colors.palette.Business_DarkThemeGeneralBackground};
    }
    .sub-label {
      color: ${theme.default.colors.palette.Business_LightThemeGreyDarker};
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
      line-height: 20px;
    }
  `
);

interface ReportMobileListItemProps {
  label: string | React.ReactNode;
  subLabel: string | React.ReactNode;
  onReportDetail: () => void;
  rightContent?: React.ReactNode;
}

const ReportMobileListItem: React.FC<ReportMobileListItemProps> = ({
  label,
  subLabel,
  onReportDetail,
  rightContent,
}) => {
  return (
    <Container onClick={onReportDetail}>
      <div className="info">
        <div className="label">{label}</div>
        {subLabel && <div className="sub-label">{subLabel}</div>}
      </div>
      {rightContent || <ButtonIcon icon="ChevronRight" size="small" $terciary />}
    </Container>
  );
};

export default ReportMobileListItem;
